// extracted by mini-css-extract-plugin
export var alt = "ParagraphBookNowBanner-module--alt--a484b";
export var container = "ParagraphBookNowBanner-module--container--3d4e1";
export var desktopOnly = "ParagraphBookNowBanner-module--desktopOnly--baf67";
export var main = "ParagraphBookNowBanner-module--main--f36ec";
export var mobileOnly = "ParagraphBookNowBanner-module--mobileOnly--db3b6";
export var textLeft = "ParagraphBookNowBanner-module--textLeft--9fc96";
export var visuallyHidden = "ParagraphBookNowBanner-module--visuallyHidden--47f01";